import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/:id',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/HotPage/:key/:id',
    name: 'HotPage',
    component: () => import('../views/HotPage.vue')
  },

]


const router = new VueRouter({
  routes
})

export default router
